<template>
    <div class="price-block">
        {{ label }}<br />
        <span v-if="addPlus">
            + </span
        ><span :class="{ blue: variant === 'blue' }">
            {{ value | numeral("$0,0") }}
        </span>
    </div>
</template>

<style lang="scss">
div.price-block {
    font-size: 12px;
    font-weight: 300;

    span {
        font-size: 16px;

        &.blue {
            font-family: $helvetica-55-Roman;
            color: $primary-blue;
            font-weight: 400;
        }
    }
}
</style>

<script>
export default {
    props: {
        label: {
            required: true,
            type: String
        },
        value: {
            required: true,
            type: Number
        },
        addPlus: {
            required: false,
            type: Boolean,
            default: false
        },
        variant: {
            required: false,
            type: String,
            default: null
        }
    }
};
</script>
